module.exports = __webpack_public_path__ + "img/fusion-all-in-one.6c860334.jpg";